import SwipeListener from "swipe-listener"

class PersonalizedReviews {
  constructor(targetEl) {
    if (
      window.__personalizedReviews &&
      window.__personalizedReviews.length > 0
    ) {
      const id = targetEl.getAttribute("data-id")
      const reviews = window.__personalizedReviews.filter(
        (item) => item.id == id
      )
      if (reviews.length) {
        this.targetEl = targetEl
        this.init(reviews[0])
      }
    }
  }

  init(review) {
    this.data = review
    this.onReview = 1

    this.textCol = this.targetEl.querySelector(
      ".personalizedReviews__col--text"
    )

    this.imageEl_1 = this.targetEl.querySelector(".personalizedReviewImage--1")
    this.imageEl_2 = this.targetEl.querySelector(".personalizedReviewImage--2")
    this.imageEl_3 = this.targetEl.querySelector(".personalizedReviewImage--3")

    this.prevEl = this.targetEl.querySelector(".personalizedReviews__prev")
    this.nextEl = this.targetEl.querySelector(".personalizedReviews__next")

    this.pagination = this.targetEl.querySelector(
      ".personalizedReviews__pagination"
    )

    this.addEventListeners()
    this.loadInitialImages()
  }

  addEventListeners() {
    this.prevEl.addEventListener("click", (event) => {
      if (this.busy) return

      this.getPrev()
    })

    this.nextEl.addEventListener("click", (event) => {
      if (this.busy) return

      this.getNext()
    })

    this.targetEl
      .querySelectorAll(".personalizedReviewImage[data-click-index]")
      .forEach((el) => {
        el.addEventListener("click", (event) => {
          if (this.busy) return

          const clickIndex = parseInt(
            event.currentTarget.getAttribute("data-click-index")
          )

          let goalIndex = this.onReview + clickIndex
          if (goalIndex > 3) {
            goalIndex = goalIndex - 3
          }
          this.getIndex(goalIndex)
        })
      })

    this.pagination.querySelectorAll("div").forEach((el) => {
      if (this.busy) return

      el.addEventListener("click", (event) => {
        const index = parseInt(event.currentTarget.getAttribute("data-index"))
        if (this.onReview != index) {
          let direction = "next"
          if (index < this.onReview) {
            direction = "prev"
          }
          this.getIndex(index, direction)
        }
      })
    })

    SwipeListener(this.targetEl.querySelector(".personalizedReviews__cols"), {
      minHorizontal: 20,
    })
    this.targetEl
      .querySelector(".personalizedReviews__cols")
      .addEventListener("swipe", (event) => {
        const directions = event.detail.directions
        if (directions.left) {
          this.getNext()
        }

        if (directions.right) {
          this.getPrev()
        }
      })

    window.addEventListener("resize", () => {
      this.resized()
    })
    this.resized()
  }

  resized() {
    let h = 0
    this.targetEl.querySelectorAll(".personalizedReviewText").forEach((el) => {
      if (el.clientHeight > h) h = el.clientHeight
    })

    this.textCol.style.minHeight = `${h}px`
  }

  loadInitialImages() {
    for (let i = 1; i <= 3; ++i) {
      const imgEl = document.createElement("img")
      imgEl.setAttribute("src", this.data.reviews[i - 1].image)
      imgEl.classList.add("current")

      this[`imageEl_${i}`].appendChild(imgEl)
    }
  }

  getPrev() {
    this.busy = true
    this.reviewToLoad = this.onReview - 1
    this.direction = "prev"

    if (this.onReview == 1) {
      this.reviewToLoad = 3
    }

    this.loadReview()
  }

  getNext() {
    this.busy = true
    this.reviewToLoad = this.onReview + 1
    this.direction = "next"

    if (this.onReview == 3) {
      this.reviewToLoad = 1
    }

    this.loadReview()
  }

  getIndex(index, direction) {
    this.busy = true
    this.reviewToLoad = index
    this.direction = direction || "next"

    this.loadReview()
  }

  loadReview() {
    this.loadNextImageSet()

    setTimeout(() => {
      this.transition()
    }, 50)
  }

  loadNextImageSet() {
    let startIndex = this.reviewToLoad - 1
    if (startIndex < 0) {
      startIndex = 2
    }

    for (let i = 1; i <= 3; ++i) {
      const imgEl = document.createElement("img")
      imgEl.setAttribute("src", this.data.reviews[startIndex].image)
      imgEl.classList.add(`incoming-${this.direction}`)

      this[`imageEl_${i}`].appendChild(imgEl)

      startIndex++
      if (startIndex == 3) {
        startIndex = 0
      }
    }
  }

  transition() {
    for (let i = 1; i <= 3; ++i) {
      const elWrapper = this[`imageEl_${i}`]
      elWrapper
        .querySelector(".current")
        .classList.add(`outgoing-${this.direction}`)
      elWrapper
        .querySelector(`.incoming-${this.direction}`)
        .classList.add(`animate-in`)
    }

    this.targetEl.querySelectorAll(".personalizedReviewText").forEach((el) => {
      if (el.getAttribute("data-index") == this.reviewToLoad) {
        el.classList.add("current")
      } else {
        el.classList.remove("current")
      }
    })

    this.targetEl
      .querySelectorAll(".personalizedReviews__pagination div")
      .forEach((el) => {
        if (el.getAttribute("data-index") == this.reviewToLoad) {
          el.classList.add("current")
        } else {
          el.classList.remove("current")
        }
      })

    setTimeout(() => {
      this.finishTransition()
    }, 300)
  }

  finishTransition() {
    for (let i = 1; i <= 3; ++i) {
      const elWrapper = this[`imageEl_${i}`]
      const newImg = elWrapper.querySelector(`.incoming-${this.direction}`)
      const oldImg = elWrapper.querySelector(".current")

      newImg.classList.add("current")
      newImg.classList.remove("animate-in", `incoming-${this.direction}`)
      oldImg.remove()
    }

    this.onReview = this.reviewToLoad
    this.busy = false
  }
}

export default PersonalizedReviews
